import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api';
import "../styles/login.css";
import logo from "../images/logo.png";
import { FaChevronLeft, FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 🔹 حالت نمایش رمز
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim()) {
      setError("لطفا نام کاربری یا شماره تلفن را وارد کنید.");
      return;
    }
    if (!password.trim()) {
      setError("لطفا رمز عبور را وارد کنید.");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('student/api/v1/student-login/', {
        username_or_phone_number: username,
        password: password,
      });

      if (response.data?.access && response.data?.refresh) {
        localStorage.setItem('accessToken', response.data.access);
        localStorage.setItem('refreshToken', response.data.refresh);
        navigate('/');
      } else {
        setError('مشکلی در پاسخ سرور پیش آمده است.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'نام کاربری یا رمز عبور اشتباه است.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='d-flex justify-content-center ' style={{ alignItems: "center", height: "100vh" }}>
      <div className="login-body">
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <div className="login_box p-lg-5 p-4">
              <div className='logo-container d-flex justify-content-center'>
                <img className='rounded-circle  p-2' src={logo} width={60} height={60} alt="logo" />
              </div>
              <span className='fs-5 d-flex justify-content-center my-4'>مجموعه آموزشی پایتون تیک</span>
              <span className='green d-flex justify-content-center mt-4'>ورود</span>
              <span className='complete-info my-2 d-flex justify-content-center'>
                برای ورود به پنل کاربری اطلاعات زیر را کامل کنید
              </span>

              {/* نمایش خطا */}
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <div className="input_box">
                <input
                  type="text"
                  id="user"
                  className="input-field"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder='تلفن همراه یا نام کاربری'
                />
              </div>

              <div className="input_box" style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"} // 🔹 تغییر حالت نمایش
                  id="pass"
                  className="input-field"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder='رمز عبور'
                />
                {/* آیکون چشم */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#555",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>

                <a style={{cursor:"pointer"}} onClick={() => navigate("/forgot-password")} className='green forget-pass'>فراموشی رمز عبور</a>
              </div>

              <div className="input_box">
                <button
                  type="submit"
                  className="input-submit"
                  disabled={loading}
                >
                  {loading ? 'در حال ورود...' : ' ورود به پنل'}
                  <FaChevronLeft className='me-2 ' style={{ fontSize: "11px" }} />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
